import { forwardRef, type SVGProps } from 'react'

export const Duplicate = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg
    ref={ref}
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M13.6889 4.35556H9.64444V0.311111C9.64444 0.14 9.50445 0 9.33333 0H0.311111C0.14 0 0 0.14 0 0.311111V9.33333C0 9.50445 0.14 9.64444 0.311111 9.64444H4.35556V13.6889C4.35556 13.86 4.49556 14 4.66667 14H13.6889C13.86 14 14 13.86 14 13.6889V4.66667C14 4.49556 13.86 4.35556 13.6889 4.35556ZM4.35556 4.66667V8.32222H1.32222V1.32222H8.32222V4.35556H4.66667C4.49556 4.35556 4.35556 4.49556 4.35556 4.66667ZM8.32222 5.67778V8.32222H5.67778V5.67778H8.32222ZM12.6778 12.6778H5.67778V9.64444H9.33333C9.50445 9.64444 9.64444 9.50445 9.64444 9.33333V5.67778H12.6778V12.6778Z'
      fill='#0958D9'
    />
  </svg>
))
